export default "__VITE_ASSET__CWWhxDic__"